import type { TutorBookingStudentProfile } from '../models/Tutor';

/** Organization-maintained first name and surname, when either is set. */
export function organizationStudentName(
  profile?: TutorBookingStudentProfile | null,
): string | null {
  const first = profile?.firstName?.trim() ?? '';
  const last = profile?.lastName?.trim() ?? '';
  const combined = `${first} ${last}`.trim();
  return combined || null;
}

/**
 * Prefer the organization student profile over the account display name.
 * `accountAlias` is the account name when it differs from the profile name.
 */
export function tutorBookingStudentNames(input: {
  studentProfile?: TutorBookingStudentProfile | null;
  userName?: string | null;
}): { primaryName: string | null; accountAlias: string | null } {
  const schoolName = organizationStudentName(input.studentProfile);
  const accountName = input.userName?.trim() || null;
  return {
    primaryName: schoolName || accountName,
    accountAlias: schoolName && accountName && schoolName !== accountName ? accountName : null,
  };
}

/** Case-insensitive substring match on school profile and/or account display name. */
export function tutorBookingMatchesStudentNameSearch(
  input: {
    studentProfile?: TutorBookingStudentProfile | null;
    userName?: string | null;
  },
  query: string,
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const { primaryName, accountAlias } = tutorBookingStudentNames(input);
  const haystack = [primaryName, accountAlias]
    .filter((value): value is string => Boolean(value))
    .join(' ')
    .toLowerCase();
  return haystack.includes(q);
}
